import clsx from 'clsx/lite';
import InvoicesPanel from 'components/Account/Invoices/InvoicesPanel';
import { type ReactNode, type FC } from 'react';
import styles from './Invoices.module.css';

interface InvoicesViewProps {
  className?: string;
  legacyInvoices?: ReactNode;
}

const InvoicesView: FC<InvoicesViewProps> = ({ legacyInvoices, className }) => (
  <div className={clsx(styles.wrapper, className)}>
    <InvoicesPanel legacyInvoices={legacyInvoices} />
  </div>
);

export default InvoicesView;
